/*eslint-disable*/
import React,{ useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'


const VendorVehicleDropdown = ({
        field: { name },
        form: { setFieldValue },
        vehicleData,
        ...props
    }) => {
   

    let options = []
    if (vehicleData && vehicleData.length > 0) {
        vehicleData.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleNumber
            temp.text = object.vehicleNumber
            temp.value = object.vehicleNumber 
            return options[index] = temp
        })
    }  

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value);
    }

    return (
        <Dropdown
            search
            selection
            clearable
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            {...props}
            fluid
        />
    )
}


export default VendorVehicleDropdown